export { default as LRUCache } from './text-metrics/lru-cache';
export { default as TextMetrics } from './text-metrics/text-metrics';
export { default as measureText } from './text-metrics/measure-text';

export * from './text-metrics/util';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-drawing/dist/es/text-metrics.js
// module id = 912
// module chunks = 29